import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { AssumedTargetAnchor } from "@xo-union/component-standard-elements";
import { createTrackableProps, TrackablePropTypes } from "@xo-union/tk-component-analytics";
import styles from "../../../../css/index.css";
const FooterLink = _ref => {
  let {
    children,
    href,
    trackableProps = {},
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(AssumedTargetAnchor, _extends({
    href: href,
    className: styles.footerLink
  }, createTrackableProps(trackableProps), rest), children);
};
process.env.NODE_ENV !== "production" ? FooterLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  trackableProps: TrackablePropTypes.trackableProps
} : void 0;
export default FooterLink;